














import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import UpdatesMainTable from "./UpdatesMainTable.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { FetchInstallationUpdatesStatusResponse } from "@/model/communication/updatesStatus/FetchInstallationUpdatesStatusResponse";
import { FetchInstallationUpdatesStatusCommand } from "@/model/communication/updatesStatus/FetchInstallationUpdatesStatusCommand";
import {
    FetchInstallationsUpdatesStatusRequestData,
    GetServerFetchInstallationsUpdatesStatusReqData,
} from "@/model/communication/updatesStatus/FetchInstallationsUpdatesStatusRequestData";
import { DownloadUpdatesStatusDataCommand } from "@/model/communication/updatesStatus/DownloadUpdatesStatusDataCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    components: {
        StandardPage,
        UpdatesMainTable,
    },
    data() {
        return {
            routes,
            dataTableItemsPerPage,
            UpdatesMainTable,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            loading: false,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                let response: FetchInstallationUpdatesStatusResponse = await new FetchInstallationUpdatesStatusCommand(
                    GetServerFetchInstallationsUpdatesStatusReqData(request)
                ).execute();
                this.loading = false;

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationUpdatesStatus request ", e);
                this.loading = false;
            }
        },

        async onDownload(exportType) {
            console.log("Download required, exportType: ", exportType);
            if (!this.loading) {
                this.loading = true;
                try {
                    let res = await new DownloadUpdatesStatusDataCommand(exportType, GetServerFetchInstallationsUpdatesStatusReqData(this.reqData)).execute();
                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();

                    this.loading = false;
                } catch (e) {
                    console.log("Something went wrong during DownloadInstallationsEnabledModulesCommand execution: ", e);
                    this.loading = false;
                }
            }
        },
    },
    mounted() {
        if (this.$route.query.reqData != null && this.$route.query.reqData != undefined) {
            this.reqData = JSON.parse(atob(this.$route.query.reqData));
        } else {
            this.reqData = new FetchInstallationsUpdatesStatusRequestData();
            this.reqData.queryLimit = this.dataTableItemsPerPage[0];
        }
    },
});
